import { DrawerParams } from "@/constants/drawer";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

export const useDrawer = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const drawerName = searchParams.get(DrawerParams.DRAWER_SEARCH_PARAM);
  const docId = searchParams.get(DrawerParams.DRAWER_DOC_ID);

  const [drawerProps, setDrawerProps] = useState({
    drawerIsOpen: drawerName ? true : false,
    drawerName,
    docId,
  });

  useEffect(() => {
    const drawerName = searchParams.get(DrawerParams.DRAWER_SEARCH_PARAM);

    setDrawerProps({
      drawerIsOpen: drawerName ? true : false,
      drawerName,
      docId: searchParams.get(DrawerParams.DRAWER_DOC_ID),
    });
  }, [searchParams]);

  const handleCloseDrawer = () => {
    searchParams.delete(DrawerParams.DRAWER_SEARCH_PARAM);
    searchParams.delete(DrawerParams.DRAWER_DOC_ID);
    searchParams.delete(DrawerParams.DOC);

    setSearchParams(searchParams);
  };

  return {
    drawerProps,
    handleCloseDrawer,
  };
};
